// extracted by mini-css-extract-plugin
module.exports = {"container":"_2dHdBxq5zaV7JrBf6ZElID"};